module.exports = __webpack_public_path__ + "img/image0x3.4512caa5.jpg";